import React from "react";
import { Space } from "@masterteam/mt-design-react";

import UpdateForm from "./UpdateForm";

import styles from "./style.module.scss";

function UpdateKPIActualValues({
  kpi,
  values,
  setFieldValue,
  errors,
  isReadOnly,
  list,
}) {
  const isSemiAuto = kpi?.DataSource?.toLowerCase() === "semi-auto";
  const hasNoBaseline = kpi?.HasNoBaseline;

  const isPercent = kpi?.UnitOfMeasure === "Percentage";

  return (
    <Space direction="vertical" size="large" className={styles.formContent}>
      {list?.map((item, index) => (
        <UpdateForm
          key={index}
          item={item}
          index={index}
          error={isReadOnly ? "" : errors?.KPIMeasures?.[index]}
          isSemiAuto={isSemiAuto}
          isPercent={isPercent}
          kpi={kpi}
          setFieldValue={setFieldValue}
          values={values}
          hasNoBaseline={hasNoBaseline}
          isReadOnly={isReadOnly}
        />
      ))}
    </Space>
  );
}

export default UpdateKPIActualValues;
